<template>
  <div>
    <b-container class="text-left">
      <h1 class="mt-2 mb-4">Elfelejtett jelszó</h1>
      <div class="bordered-container mt-3">
        <h6 class=" mb-5">
          Adja meg email címét, hogy új jelszót állíthassunk be Önnek.
        </h6>
        <b-row class="mt-4">
          <b-col>
            <b-form>
              <b-form-group id="input-group-1" label-for="forgot_email" description="">
                <label>Email</label>

                <b-form-input
                  id="forgot_email"
                  type="email"
                  required
                  placeholder="Email cím"
                  v-model="email"
                  class="border mb-5"
                ></b-form-input>
              </b-form-group>

              <b-button
                type="submit"
                variant="primary"
                @click.prevent="onPasswordResetSubmission"
                :disabled="isLoading"
                class="mt-2 mb-2 w-100"
                size="md"
              >
                <b-spinner small v-if="isLoading"></b-spinner>
                <span class="sr-only" v-if="isLoading">Betöltés...</span>
                <span v-if="!isLoading">Új jelszó igénylése</span>
              </b-button>
            </b-form>
          </b-col>
        </b-row>
      </div>
    </b-container>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  data() {
    return {
      email: ''
    }
  },
  computed: {
    ...mapGetters(['isLoading'])
  },
  methods: {
    async onPasswordResetSubmission() {
      if (!this.email.length) {
        this.$store.dispatch('notify', {
          newNotification: { type: 'warning', message: 'Az összes mező kitöltése kötelező!' }
        })
        return
      }

      const emailValidation = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/

      if (!emailValidation.test(this.email)) {
        this.$store.dispatch('notify', {
          newNotification: { type: 'warning', message: 'Az email cím formátuma nem megfelelő' }
        })
        return
      }

      await this.$store.dispatch('initiatePasswordReset', this.email)
      this.$store.dispatch('notify', {
        newNotification: { type: 'success', message: 'A jelszó emlékeztető elküldve.' }
      })
    }
  }
}
</script>

<style scoped>
.bordered-container {
  max-width: 600px;
  margin: 0;
}
</style>
